// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__su6ux"};